import * as React from 'react';
import cx from 'classnames';
import { Button } from '@common/components/Button';

import './back-btn.styles.scss';

export type BackBtnProps = {
  className?: string;
  onClick: () => void;
};

export const BackBtn: React.FC<BackBtnProps> = (props) => {
  const { onClick, className } = props;
 
  return (
    <Button 
      className={cx(
        'FhqDesignToolBackBtn', 
        className
      )}
      onClick={onClick}
      variant="text"
    >
      {'< '}Back
    </Button>
  );
};